import { get } from '../utils/api';
export default class CamReconciliationTypesService {
  getAll(signal?: Object) {
    const options = signal ? { signal } : {};
    return get('/cam-reconciliation-types', options);
  }
}
